import { jsx as a } from "react/jsx-runtime";
import s from "classnames";
import o from "./index.es5621.js";
const n = ({
  actions: i,
  actionsOrientation: t,
  testId: r
}) => /* @__PURE__ */ a(
  "div",
  {
    className: s(o.confirmationDialogActions, {
      [o.vertical]: t === "vertical"
    }),
    "data-testid": r,
    children: i
  }
);
export {
  n as ConfirmationDialogBoxActions
};
//# sourceMappingURL=index.es788.js.map
